var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.405,
    height: 24.664,
    viewBox: "0 0 15.405 24.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38176",
    "data-name": "Path 38176",
    d: "M523.943,35.3H512.076a1.77,1.77,0,0,0-1.769,1.769V58.2a1.769,1.769,0,0,0,1.769,1.766h11.867a1.769,1.769,0,0,0,1.769-1.766V37.07A1.77,1.77,0,0,0,523.943,35.3ZM515.33,37.35h5.359a.466.466,0,1,1,0,.932H515.33a.466.466,0,0,1,0-.932Zm8.085,17.909H512.606V40.007h10.809Z",
    transform: "translate(-510.307 -35.301)",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/Mobile.810df3c3070b40cbc1da82ccdf6fb709.svg";
export { ForwardRef as ReactComponent };